// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"50b1f994","977":"452f0dbf"}[chunkId] + ".chunk.js";
};